import { basicMsg } from "../../actions/swal_msg";
import { clearStoredSession, isAuthSessionError } from '../sessionHelper';

export const checkUserSession = (msg) => {
    if (isAuthSessionError(msg)) {
        clearStoredSession();
        basicMsg("Su sesión expiró");
        return false;
    } else return true;
};
